import React from 'react'

const PrivacyAndPolicy = () => {
  return (
    <>
     <div className="container my-4">
      <div className="card shadow p-4">
        <h2 className="mb-3">Privacy Policy — Evolve Brands Pvt Ltd (DPDP 2023 Compliant)</h2>
        <p><strong>Effective Date:</strong> 01-01-2023</p>
        <p><strong>Last Updated:</strong> 12-06-2025</p>

        <h4 className="mt-4">1. Introduction</h4>
        <p>
          At Evolve Brands Pvt. Ltd. ("EBPL", "we", "us", "our"), your privacy is of utmost importance.
          This Privacy Policy explains how we collect, process, store, share, and safeguard your personal
          data, in accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act, India).
        </p>
        <p>
          By accessing or using our Services (website, app, or loyalty platform), you consent to this policy.
        </p>

        <h4 className="mt-4">2. Definitions</h4>
        <ul>
          <li><strong>Personal Data:</strong> Data about an identifiable individual.</li>
          <li><strong>Data Principal:</strong> You, the data subject.</li>
          <li><strong>Data Fiduciary:</strong> Evolve Brands Pvt Ltd.</li>
          <li><strong>Data Processor:</strong> Third parties processing data on our behalf.</li>
          <li><strong>Consent:</strong> Informed, voluntary agreement to process data.</li>
        </ul>

        <h4 className="mt-4">3. Applicability</h4>
        <ul>
          <li>Users in India using our services.</li>
          <li>Data collected via app, website, offline methods.</li>
          <li>Processing by EBPL or authorized third parties.</li>
        </ul>

        <h4 className="mt-4">4. Data We Collect</h4>
        <h6>4.1 Personal Data You Provide</h6>
        <ul>
          <li>Full Name</li>
          <li>Date of Birth</li>
          <li>Gender</li>
          <li>Email Address</li>
          <li>Mobile Number</li>
          <li>Address</li>
          <li>Company & Position</li>
          <li>PAN / Aadhaar (as legally permitted)</li>
          <li>Bank/UPI Details</li>
          <li>Customer Interaction Data</li>
          <li>Consent Records</li>
        </ul>

        <h6>4.2 End User Data (if applicable)</h6>
        <ul>
          <li>Customer Name</li>
          <li>Contact Details</li>
          <li>Purchase/Transaction History</li>
          <li>Loyalty Points</li>
        </ul>

        <h6>4.3 Data Collected Automatically</h6>
        <ul>
          <li>IP Address</li>
          <li>Device Info</li>
          <li>Browser Type</li>
          <li>Cookies/Tracking</li>
          <li>Location</li>
          <li>App Usage</li>
          <li>Log Files</li>
        </ul>

        <h4 className="mt-4">5. Purpose of Processing</h4>
        <ul>
          <li>Registration & verification</li>
          <li>Loyalty program management</li>
          <li>Rewards & redemption</li>
          <li>Customer support</li>
          <li>Fraud prevention</li>
          <li>Analytics & improvements</li>
          <li>Legal compliance</li>
          <li>Promotional & transactional communication</li>
        </ul>

        <h4 className="mt-4">6. Legal Basis for Processing</h4>
        <ul>
          <li>Consent</li>
          <li>Performance of Contract</li>
          <li>Legal Obligation</li>
          <li>Legitimate Interest</li>
        </ul>

        <h4 className="mt-4">7. Consent Management</h4>
        <ul>
          <li>Explicit consent is taken before data collection.</li>
          <li>Consent can be withdrawn anytime via contact (Section 14).</li>
        </ul>

        <h4 className="mt-4">8. Data of Children</h4>
        <ul>
          <li>No collection from individuals under 18 without parental consent.</li>
          <li>Parental consent must be verifiable.</li>
        </ul>

        <h4 className="mt-4">9. Data Retention</h4>
        <ul>
          <li>Data retained only as long as needed.</li>
          <li>Post-purpose, data is deleted or anonymized.</li>
        </ul>

        <h4 className="mt-4">10. Your Rights</h4>
        <ul>
          <li><strong>Access:</strong> Know what data we process.</li>
          <li><strong>Correction:</strong> Update outdated/inaccurate data.</li>
          <li><strong>Erasure:</strong> Delete data after purpose ends.</li>
          <li><strong>Grievance Redressal:</strong> Lodge complaints.</li>
          <li><strong>Nominate:</strong> Assign someone to manage your rights.</li>
        </ul>

        <h4 className="mt-4">11. Data Sharing and Disclosure</h4>
        <ul>
          <li>With third-party service providers (payments, IT, etc.).</li>
          <li>With affiliates/business partners under agreements.</li>
          <li>As required by law or authorities.</li>
          <li>During mergers/acquisitions (with notice).</li>
          <li><strong>Note:</strong> We do not sell your personal data.</li>
        </ul>

        <h4 className="mt-4">12. Cross-Border Data Transfer</h4>
        <ul>
          <li>Transfers only to countries with adequate safeguards.</li>
          <li>Contractual protections are ensured.</li>
        </ul>

        <h4 className="mt-4">13. Data Security Measures</h4>
        <ul>
          <li>Encryption (TLS)</li>
          <li>Access controls</li>
          <li>Secure cloud infrastructure</li>
          <li>Employee confidentiality agreements</li>
          <li>Regular audits</li>
          <li>Incident response protocols</li>
        </ul>

        <h4 className="mt-4">14. Grievance Officer</h4>
        <ul>
          <li><strong>Name:</strong> Seema Motwani</li>
          <li><strong>Designation:</strong> Associate Vice President</li>
          <li><strong>Email:</strong> seemam@evolvebrands.com</li>
          <li><strong>Response Time:</strong> Within 7 days</li>
        </ul>

        <h4 className="mt-4">15. Automated Decision Making & Profiling</h4>
        <ul>
          <li>No fully automated decisions affecting rights.</li>
          <li>Profiling used only with consent for personalization.</li>
        </ul>

        <h4 className="mt-4">16. Updates to This Policy</h4>
        <ul>
          <li>Policy may be updated periodically.</li>
          <li>Updates will be shared via website, email, or app notification.</li>
        </ul>

        <h4 className="mt-4">17. Contact Information</h4>
        <ul>
          <li><strong>Company:</strong> Evolve Brands Pvt Ltd</li>
          <li><strong>Address:</strong> GS Tower, 112, 4th Floor, Udyog Vihar Phase 1, Sector 20, Gurugram, Haryana 122008, India</li>
          <li><strong>Email:</strong> info@evolvebrands.com</li>
        </ul>
      </div>
    </div>
    </>
  )
}

export default PrivacyAndPolicy